// extracted by mini-css-extract-plugin
export var dropdownButton = "_3n-0";
export var fullWidthDropdownButton = "_3n-1";
export var icon = "_3n-3";
export var iconPlaceholder = "_3n-2";
export var menuItemRow = "_3n-8";
export var separator = "_3n-c";
export var shortcutContainer = "_3n-7";
export var shortcutIconLg = "_3n-6";
export var shortcutIconMd = "_3n-5";
export var shortcutIconSm = "_3n-4";
export var submenuChevron = "_3n-b";
export var submenuDropdown = "_3n-9";
export var submenuTriggerRow = "_3n-a";